import * as React from 'react';

import i18n from 'helper/i18n';
export type LevelSpec = {
	label: string;
	text: string;
};

export type LevelProps = {
	preselected: number | null;
	levels?: LevelSpec[]; // has default levels!
	onChange?: Function;
};

export type LevelState = {
	selectedLevel: number | null;
	preselectedSet: boolean;
};

const labelBase = 'react.impulsCoach.components.Level';

export const getStep = (type: string): LevelSpec => ({
	label: i18n(`${labelBase}.${type}.title`),
	text: i18n(`${labelBase}.${type}.text`),
});

export class Level extends React.Component<LevelProps, LevelState> {
	public static defaultProps = {
		preselected: 0,
		levels: [getStep('low'), getStep('medium'), getStep('high')],
	};

	constructor(props: LevelProps) {
		super(props);

		const initialLevel = props.preselected ? props.preselected : 0;

		this.state = {
			selectedLevel: initialLevel,
			preselectedSet: !!(initialLevel >= 1),
		};
	}

	public componentDidUpdate(prevProps: LevelProps) {
		if (this.props.preselected! >= 1 && !this.state.preselectedSet) {
			this.setState({
				selectedLevel: this.props.preselected,
				preselectedSet: true,
			});
		}
	}

	public onSelectActivityLevel(level: number) {
		this.setState(
			{
				selectedLevel: level,
			},
			() => {
				if (typeof this.props.onChange === 'function') {
					this.props.onChange.apply(null, [level]);
				}
			}
		);
	}

	public renderLevel(level: LevelSpec, index: number) {
		return (
			<div
				key={`level-${index}`}
				onClick={() => this.onSelectActivityLevel(index + 1)}
				className={`m-level__item${
					index + 1 === this.state.selectedLevel ? ' state-m-level__item--selected' : ''
				}`}
			>
				<div className="m-level__stripes">
					<div className="m-level__stripes-layer" />
				</div>
				<div className="m-level__item-label">{level.label}</div>
			</div>
		);
	}

	public renderLevelText(): any {
		if (
			this.props.levels &&
			typeof this.state.selectedLevel === 'number' &&
			this.state.selectedLevel >= 1 &&
			this.props.levels[this.state.selectedLevel - 1] &&
			this.props.levels[this.state.selectedLevel - 1].text
		) {
			return (
				<p className="m-level__text">
					{this.props.levels[this.state.selectedLevel - 1] &&
						this.props.levels[this.state.selectedLevel - 1].text}
				</p>
			);
		}

		return <p className="m-level__text">&nbsp;</p>;
	}

	public render() {
		const _this = this;

		return (
			<div className="m-level">
				<div className="m-level__box">
					<div className="m-level__select">{(this.props.levels || []).map(this.renderLevel.bind(_this))}</div>
					<svg className="m-level__triangle" viewBox="0 0 200 100" preserveAspectRatio="none">
						<polygon points="0,100 0,0 200,0" />
					</svg>
				</div>
				{this.renderLevelText()}
			</div>
		);
	}
}

export default Level;
